




























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { TableContext, DataTableState } from '@/typings/datatable';

@Component({})
export default class DataTable extends Vue {
	@Prop(Object)
	public readonly state?: DataTableState;

	@Prop(Function)
	public readonly provider?: () => void;

	@Prop(String)
	public readonly id?: string;

	@Prop(Function)
	public readonly clickTable?: (item: any, newtab: boolean, index: number, e: Event) => void;

	@Prop(String)
	public readonly rowIdField?: string;
}
